module.exports = __webpack_public_path__ + "static/coho-rel-779d6ec04f901211e37be28b4a324be3.png";